import Vue from 'vue';

const id = 'smcApp';

const SMC = {
	Init() {
		if (document.getElementById(id)) {
			// eslint-disable-next-line no-new
			new Vue({
				el: `#${id}`,
				data: {
					filter: {
						programType: '',
						county: '*',
						day: '*',
						format: '*'
					},
					itemCount: 0,
					start: true
				},
				methods: {
					update() {
						setTimeout(() => {
							this.itemCount = $('.sm-program--search-results li:visible').length;
							this.start = false;
						}, 150);
					}
				},
				created() {
					this.filter.programType = document.getElementById(id).dataset.program;
					if (URLSearchParams) {
						const urlParams = new URLSearchParams(window.location.search);
						if (urlParams.has('program')) {
							this.filter.programType = urlParams.get('program');
						}
					}
					this.update();
				}
			});
		}
	}
};

export default SMC;
